var REGION_AGNOSTIC_PATHS = ['/v1/users/*', '/v1/account/*', '/v1/groups/*', '/v1/permissions', '/v1/tokens/*', '/v1/oidc/*', '/v1/tasks/*', '/v1/enabled-features', '/v1/ws/token', '/v1/resellers/distributors', '/v1/docs', '/v1/docs.json', '/v2/docs', '/v2/docs.json'];
export var REGION_HEADER = 'X-Target-Region';
export var isRegionAgnosticPath = function isRegionAgnosticPath(url) {
    if (!url)
        return false;
    var path = url.split('?')[0];
    return REGION_AGNOSTIC_PATHS.some(function (entry) {
        if (entry.endsWith('/*')) {
            var base = entry.split('/*')[0];
            return path === base || path.startsWith("".concat(base, "/"));
        }
        return path === entry;
    });
};
